import { __generator } from "tslib";
import { all, put } from 'redux-saga/effects';
import { initPostStream, initGallectionStream, initBrowseStream, deselectAll, unsetCurrentFolderId, unsetSearchQuery, unsetSearchInput, } from '../actions';
import { MediaSourceType } from '../types';
export default function (action) {
    var payload, mediaSource, actionsToPut;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                if (!payload) {
                    return [2 /*return*/];
                }
                mediaSource = payload;
                actionsToPut = [
                    deselectAll(),
                    unsetCurrentFolderId(),
                    unsetSearchQuery(),
                    unsetSearchInput(),
                ];
                if ([
                    MediaSourceType.GALLERY,
                    MediaSourceType.COLLECTION,
                    MediaSourceType.STASH,
                ].includes(mediaSource)) {
                    actionsToPut.push(initGallectionStream({}));
                }
                else if ([
                    MediaSourceType.POLL,
                    MediaSourceType.STATUS,
                    MediaSourceType.JOURNAL,
                    MediaSourceType.POSTS,
                ].includes(mediaSource)) {
                    actionsToPut.push(initPostStream(mediaSource));
                }
                else if (mediaSource === MediaSourceType.BROWSE) {
                    actionsToPut.push(initBrowseStream());
                }
                return [4 /*yield*/, all(actionsToPut.map(function (actionToPut) { return put(actionToPut); }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=changeCurrentMediaSource.js.map